import React, { useContext, useState } from "react";
import {
  ALL_SYSTEM_CODES_QUERY,
  SYSTEM_CODE_PAGINATION_QUERY
} from "../../../graphql/SystemCodes/SystemCodes.graphql";

import {
  AddSystemCodeForm,
  EditSystemCodeForm
} from "../../../components/SystemCodes";
import { ModalContext } from "../../../components/ModalProvider";

import DataTable from "../../../components/DataTable";

import { COLUMNS } from "./columns";

import PageHeader from "../../../components/PageHeader";

import SystemCodeFilters from "./SystemCodeFilters";
import { getFilterState, saveFilterState } from "../../../utils";

const SystemCodesPage = () => {
  const INITIAL_FILTER_STATE = getFilterState("SYSTEM_CODE_FILTERS", {
    Type: "User",
    Active: true
  });

  const [filters, setFilters] = useState(INITIAL_FILTER_STATE);
  const { setModalOpen } = useContext(ModalContext);

  const handleSetFilters = inputs => {
    // Clearing filters if is empty and avoid null response from query
    Object.keys(inputs).forEach(key => {
      if (typeof inputs[key] !== "boolean") {
        if (
          !inputs[key] ||
          inputs[key] === 0 ||
          inputs[key] === "" ||
          inputs[key] === "0"
        ) {
          delete inputs[key];
        }
      }
    });

    // Seting up the Filters values
    const Filters = {};
    Object.keys(inputs).forEach(
      key =>
        (Filters[key] =
          inputs[key] && inputs[key].value ? inputs[key].value : inputs[key])
    );
    setFilters(Filters);
    saveFilterState("SYSTEM_CODE_FILTERS", Filters);
  };
  const resetFilters = () => handleSetFilters({ Active: true });

  return (
    <React.Fragment>
      <PageHeader
        FilterComponent={SystemCodeFilters}
        columns={COLUMNS}
        filters={filters}
        name="SystemCodes"
        orderByMulti={["Category_ASC", "CodeName_ASC", "ListOrder_ASC"]}
        query={ALL_SYSTEM_CODES_QUERY}
        resetFilters={resetFilters}
        setFilters={handleSetFilters}
        title="System Codes"
        onAddClick={() => {
          setModalOpen(
            true,
            <AddSystemCodeForm setModalOpen={() => setModalOpen(false, "")} />
          );
        }}
      />
      <DataTable
        columns={COLUMNS}
        dataQuery={ALL_SYSTEM_CODES_QUERY}
        initialSortBy={[
          { id: "Category", desc: false },
          { id: "CodeName", desc: false },
          { id: "ListOrder", desc: false }
        ]}
        name="SystemCode"
        paginationQuery={SYSTEM_CODE_PAGINATION_QUERY}
        where={{ Type: "User", Active: true, ...filters }}
        onRowClick={data =>
          setModalOpen(
            true,
            <EditSystemCodeForm
              code={data}
              setModalOpen={() => setModalOpen(false, "")}
            />
          )
        }
      />
    </React.Fragment>
  );
};

// function SystemCodesPage() {
//   const [filters, setFilters] = useState({ Active: true });
//   const [showFilters, setShowFilters] = useState(false);
//   const client = useApolloClient();
//   const { setModalOpen } = useContext(ModalContext);

//   const updateFilters = e => {
//     if (["false", "true"].includes(e.target.value)) {
//       const value = e.target.value !== "false";
//       setFilters({ ...filters, [e.target.name]: value });
//     } else {
//       setFilters({ ...filters, [e.target.name]: e.target.value });
//     }
//   };

//   return (
//     <Section
//       title="System Codes"
//       links={[
//         {
//           action: () => setShowFilters(!showFilters),
//           text: "Filter",
//           icon: "filter"
//         },
//         {
//           action: () =>
//             downloadCSV(
//               client,
//               {
//                 query: ALL_SYSTEM_CODES_QUERY
//               },
//               "SystemCodes"
//             ),
//           text: "Export",
//           icon: "file-export"
//         },
//         {
//           content: (
//             <TabLinkModalTrigger
//               text="Add"
//               icon="plus"
//               ModalContent={() => (
//                 <AddSystemCodeForm
//                   setModalOpen={() => setModalOpen(false, "")}
//                 />
//               )}
//             />
//           )
//         }
//       ]}
//     >
//       {showFilters && (
//         <SystemCodeFilters
//           filters={filters}
//           onChange={updateFilters}
//           resetFilters={() => setFilters({ Active: true })}
//         />
//       )}
//       <DataTable
//         columns={COLUMNS}
//         dataQuery={ALL_SYSTEM_CODES_QUERY}
//         paginationQuery={SYSTEM_CODE_PAGINATION_QUERY}
//         name="SystemCode"
//         where={{ Type: "User", Active: true, ...filters }}
//         initialSortBy={[
//           { id: "Category", desc: true },
//           { id: "CodeName", desc: true },
//           { id: "ListOrder", desc: true }
//         ]}
//         onRowClick={data =>
//           setModalOpen(
//             true,
//             <EditSystemCodeForm
//               setModalOpen={() => setModalOpen(false, "")}
//               code={data}
//             />
//           )
//         }
//       />
//     </Section>
//   );
// }

SystemCodesPage.propTypes = {};

export default SystemCodesPage;
